import { render, staticRenderFns } from "./Municipality-main.vue?vue&type=template&id=37d30844&"
import script from "./Municipality-main.vue?vue&type=script&lang=js&"
export * from "./Municipality-main.vue?vue&type=script&lang=js&"
import style0 from "./Municipality-main.vue?vue&type=style&index=0&id=37d30844&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports